<template>
	<div style="position: relative; z-index:99999999">
		<el-dialog @close="closeDialog" title="学制分数统计" width="800px" :visible.sync="visible"
			:close-on-click-modal="false">
			<table class="dtable">
				<tr>
					<th colspan="6">
						{{ DataList.title }}【计划：{{DataList.plan}}】【招生：{{DataList.score?DataList.score.zscount:0}}】
					</th>
				</tr>
				
				<tr>
					<td style="width:200px">专业</td>
					<td>招生计划</td>
					<td>实招人数</td>
					<td>平均分</td>
					<td>最高分</td>
					<td>最低分</td>
					<td>已缴费</td>
                            <td>已确认</td>
                            <td>已录取</td>
				
				</tr>
				<tr v-for="(m, i) in DataList.majors" :key="i">
					<td>
						{{ m.title }}
					</td>
					<td>
						{{ m.item_plan }}
					</td>
					<td>
						{{ m.score ? m.score.zscount : '' }}
					</td>
					<td>
						{{ m.score ? m.score.avg : '' }}
					</td>
					<td>
						{{ m.score ? m.score.max : '' }}
					</td>
					<td>
						{{ m.score ? m.score.min : '' }}
					</td>
					<td>
						{{ m.jiaofei ? m.jiaofei : '' }}
					</td>
					<td>
						{{ m.queren ? m.queren : '' }}
					</td>
					<td>
						{{ m.fenban ? m.fenban : '' }}
					</td>
				</tr>
			</table>

		</el-dialog>
	</div>
</template>

<script>
export default {
	props: ["zsdata"],
	components: {
	},
	data() {
		return {
			visible: true,
			xibuInfo: { title: "", zs_count: 0 },
			DataList: {}
		}
	},
	mounted() {


		this.DataList = this.zsdata
		// console.log(this.DataList)
	},
	methods: {
		closeDialog() {
			this.$parent.datashow = false
		}
	}
}
</script>

<style>
</style>
